export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10825.c98d96b7.jpg";